<template>
    <div>
        <h5 v-if="diffs.length === 0" class="mt-3">Aucune différence détectée</h5>

        <div v-for="diff in diffs">
            <!--                TEXT DIFFS-->
            <div v-if="getField(diff.dataType).type === 'text'" class="mt-6">
                <label>
                    <strong>{{ getField(diff.dataType).label }}</strong>
                </label>
                <text-field-diffs-vt :diff="diff" v-if="vt"></text-field-diffs-vt>
                <text-field-diffs :diff="diff" v-else></text-field-diffs>
            </div>

            <!-- EMAIL OR PHONE DIFFS -->
            <div v-if="getField(diff.dataType).type === 'phonesOrEmails'" class="mt-6">
                <label>
                    <strong>{{ getField(diff.dataType).label }}</strong>
                </label>
                <email-or-phone-diff-vt :diff="diff" v-if="vt"></email-or-phone-diff-vt>
                <email-or-phone-diffs :diff="diff" v-else></email-or-phone-diffs>
            </div>

            <!--                TEXTAREA DIFFS-->
            <div v-else-if="getField(diff.dataType).type === 'textarea'" class="mt-6">
                <label>
                    <strong>{{ getField(diff.dataType).label }}</strong>
                    <img
                      v-if="diff.metadata && diff.metadata.language_id"
                      :src="'/images/flags/' + getLanguageCode(diff.metadata.language_id) + '.png'"
                      height="20px"
                      class="ml-2">
                </label>
                <text-area-diffs :diff="diff"></text-area-diffs>
            </div>

            <!--                ELEMENTS DIFFS-->
            <div v-else-if="getField(diff.dataType).type === 'select'" class="mt-6">
                <label>
                    <strong>{{ getField(diff.dataType).label }}</strong>
                </label>
                <element-field-diffs :diff="diff"></element-field-diffs>
            </div>

            <!--                MEDIAS DIFFS-->
            <div v-else-if="getField(diff.dataType).type === 'image'" class="mt-6">
                <label>
                    <strong>{{ getField(diff.dataType).label }}</strong>
                </label>
                <media-field-diffs :diff="diff"></media-field-diffs>
            </div>

            <!--                GPS DIFFS-->
            <div v-else-if="getField(diff.dataType).type === 'map'" class="mt-6">
                <label>
                    <strong>{{ getField(diff.dataType).label }}</strong>
                </label>
                <gps-field-diffs :diff="diff"></gps-field-diffs>
            </div>

            <!--                OPENING PERIODS DIFFS-->
            <div v-else-if="getField(diff.dataType).type === 'opening'" class="mt-6">
                <label>
                    <strong>{{ getField(diff.dataType).label }}</strong>
                </label>
                <google-opening-period-field-diffs :diff="diff" v-if="vt"></google-opening-period-field-diffs>
                <opening-period-field-diffs :diff="diff" v-else></opening-period-field-diffs>
            </div>

            <!--                PRICES DIFFS-->
            <div v-else-if="getField(diff.dataType).type === 'prices'" class="mt-6">
                <label>
                    <strong>{{ getField(diff.dataType).label }}</strong>
                </label>
                <price-period-field-diffs :diff="diff"></price-period-field-diffs>
            </div>

            <!--                CONTACT DIFFS-->
            <div v-else-if="getField(diff.dataType).type === 'contactBloc'" class="mt-6">
                <label>
                    <strong>{{ getField(diff.dataType).label }}</strong>
                </label>
                <contact-field-diffs :diff="diff"></contact-field-diffs>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"
import { answerDiffsFieldsLabel } from "../../../static/answerDiffsFieldsLabel"
import TextFieldDiffs from "./fieldsDiffs/TextFieldDiffs.vue"
import TextAreaDiffs from "./fieldsDiffs/TextAreaDiffs.vue"
import ElementFieldDiffs from "./fieldsDiffs/ElementFieldDiffs.vue"
import MediaFieldDiffs from "./fieldsDiffs/MediaFieldDiffs.vue"
import GpsFieldDiffs from "./fieldsDiffs/GpsFieldDiffs.vue"
import OpeningPeriodFieldDiffs from "./fieldsDiffs/OpeningPeriodFieldDiffs.vue"
import PricePeriodFieldDiffs from "./fieldsDiffs/PricePeriodFieldDiffs.vue"
import ContactFieldDiffs from "./fieldsDiffs/ContactFieldDiffs.vue"
import EmailOrPhoneDiffs from "./fieldsDiffs/EmailOrPhoneDiffs.vue"
import GoogleOpeningPeriodFieldDiffs from "./fieldsDiffs/GoogleOpeningPeriodFieldDiffs.vue"
import TextFieldDiffsVt from "./fieldsDiffs/TextFieldDiffsVt.vue"
import EmailOrPhoneDiffVt from "./fieldsDiffs/EmailOrPhoneDiffVt.vue"

export default {
    name: "SitAnswerDiffsStep",
    props: ["languages", 'vt',],
    components: {
        TextFieldDiffs,
        TextAreaDiffs,
        ElementFieldDiffs,
        MediaFieldDiffs,
        GpsFieldDiffs,
        OpeningPeriodFieldDiffs,
        PricePeriodFieldDiffs,
        ContactFieldDiffs,
        EmailOrPhoneDiffs,
        GoogleOpeningPeriodFieldDiffs,
        TextFieldDiffsVt,
        EmailOrPhoneDiffVt,
    },
    methods: {
        getField(dataType) {
            return answerDiffsFieldsLabel.find(field => field.name === dataType)
        },
        getLanguageCode(id) {
            return this.languages.find(language => language.id === id).code
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "diffs",
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>